module.exports = Ammo;


//////////////////
// WEBPACK FOOTER
// external "Ammo"
// module id = 214
// module chunks = 0